<template>
    <div>
        <p id="loadingMessage">{{ loadingMessage }}</p>
        <canvas ref="canvas" class="w-100" style="display: none;"></canvas>
        <div ref="outputContainer" style="display: none;">
            <p id="outputMessage" ref="outputMessage" style="display: none;"></p>
            <div ref="outputData" style="display: none;">
                <p>Data:</p>
                <p>{{ outputData }}</p>
            </div>
        </div>
        <video ref="video" playsinline autoplay hidden></video>
    </div>
</template>

<script>
export default {
    name: 'JsQrReader',
    data() {
        return {
            loadingMessage: '⌛ Loading video...',
            outputData: '',
            animationFrameId: null,
        };
    },
    mounted() {
        this.startCamera();
    },
    beforeDestroy() {
        cancelAnimationFrame(this.animationFrameId);
        if (this.$refs.video && this.$refs.video.srcObject) {
            this.$refs.video.srcObject.getTracks().forEach(track => track.stop());
        }
    },
    methods: {
        startCamera() {
            navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
                .then((stream) => {
                    this.$refs.video.srcObject = stream;
                    this.$refs.video.play();
                    this.animationFrameId = requestAnimationFrame(this.tick);
                })
                .catch((err) => {
                    console.error('Error accessing the camera:', err);
                });
        },
        tick() {
            if (!this.$refs.video) {
                return;
            }
            if (this.$refs.video.readyState === this.$refs.video.HAVE_ENOUGH_DATA) {
                this.loadingMessage = '';
                this.$refs.canvas.style.display = 'block';
                this.$refs.outputContainer.style.display = 'block';

                this.$refs.canvas.height = this.$refs.video.videoHeight;
                this.$refs.canvas.width = this.$refs.video.videoWidth;
                const canvas = this.$refs.canvas.getContext('2d');
                canvas.drawImage(this.$refs.video, 0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
                const imageData = canvas.getImageData(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);

                const code = jsQR(imageData.data, imageData.width, imageData.height, {
                    inversionAttempts: 'dontInvert',
                });

                if (code) {
                    this.$refs.outputMessage.style.display = 'none';
                    this.outputData = code.data;

                    this.drawLine(code.location.topLeftCorner, code.location.topRightCorner, '#FF3B58');
                    this.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, '#FF3B58');
                    this.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, '#FF3B58');
                    this.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, '#FF3B58');

                    this.$emit('code-detected', code.data); // Emitir o código detectado para o componente pai
                } else {
                    this.$refs.outputMessage.style.display = 'block';
                }
            }
            this.animationFrameId = requestAnimationFrame(this.tick); // Chamar o método tick novamente para leitura contínua
        },
        drawLine(begin, end, color) {
            const canvas = this.$refs.canvas.getContext('2d');
            canvas.beginPath();
            canvas.moveTo(begin.x, begin.y);
            canvas.lineTo(end.x, end.y);
            canvas.lineWidth = 4;
            canvas.strokeStyle = color;
            canvas.stroke();
        },
    },
};
</script>
